<template>
<div class='user'>

  <!-- info usuario -->
  <section class="header profile">
    <div class = "container columns">
      <div class = "profile">
        <div class="picture">
          <img v-if="myUserInfo.picture" :src="myUserInfo.picture" />
          <img v-else src="/static/img/student.png" />
        </div>

        <div class = "profile-info">
          <p class="name">
            <span v-if="myUserInfo.name">{{ myUserInfo.name }}</span>
            <span v-else>Tu nombre</span>
          </p>
          <p class="description">{{ myUserInfo.description }}</p>
        </div>
      </div>

      <router-link :to="{ name: 'usersettings'}">
        Editar Perfil
        <span class="icon"><i class="mdi mdi-pencil"></i></span>
      </router-link>
    </div>
  </section>

  <!-- tab area -->
  <section class = "tab-area">
    <div class = " container-full">
      <b-tabs position = "is-centered" v-model="activeTab"  type="is-boxed">
        <b-tab-item label="Tus proyectos">
          <UserProjectListing />
        </b-tab-item>

        <b-tab-item label="Tus clases">
          <UserClassArea />
        </b-tab-item>

        <b-tab-item  label="Área profesor">
          <UserTeacherArea />
          <!--
          <iframe src="https://giphy.com/embed/ZTans30ONaaIM" width="480" height="299" frameBorder="0" class="giphy-embed"></iframe>
          <p>Estamos trabajando en esta sección, volverá en breve</p>
          -->
        </b-tab-item>
      </b-tabs>
    </div>
  </section>

  <Footer/>
</div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import Footer from '../UI/Footer'
import UserProjectListing from './UserProjectListing'
import UserClassArea from './UserClassArea'
import UserTeacherArea from './UserTeacherArea'

export default {
  name: 'User',
  components: {
    Footer,
    UserProjectListing,
    UserClassArea,
    UserTeacherArea
  },
  data: () => ({
    activeTab: 0,
    myProjectsCurrentPage: 1
  }),
  props: {},
  computed: {
    myUserInfo () {
      return this.$store.state.user.userInfo
    },
    myProjects () {
      return this.$store.getters['user/myProjectList']
      // return this._.flatten(this.$store.state.user.myProjectListResponses.pages)
    },
    editorConfig () {
      return this.$store.state.editorConfig
    },
    showPagination () {
      // show pagination only if: count is bigger thatn the results in the query and I am not in the last page
      return ((this.$store.state.user.myProjectListResponses.count > this.$store.state.user.projectsPerQuery) && (this.myProjectsCurrentPage * this.$store.state.user.projectsPerQuery < this.$store.state.user.myProjectListResponses.count))
    }
  },
  methods: {
    loadUserInfo: function () {
      this.$store.dispatch('user/fetchUserInfo')
      this.$store.dispatch('user/fetchMyProjects')
    },
    goToAdd: function () {
      this.showAddClassroom = true
      VueScrollTo.scrollTo('#add-class-block', 1000)
    },
    getClassroomName: function (classid) {
      if (classid === null) return null
      let classroom = this._.find(this.$store.state.user.userInfo.classroom_set, ['id', classid])
      if (classroom !== undefined) {
        return classroom.name
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.$store.dispatch('fetchExamplesList')
  },
  created () {
    this.$store.commit('setEditorConfigProperty', {'isShowingSettings': false})
    this.loadUserInfo()
  }
}
</script>

<style lang="less" scoped>
@import (reference) "../../assets/styles/main.less";

.user {
  padding-top: 50px;

  .list {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .project {
      min-width: 120px;
      margin-bottom: 4em;
      margin-right: 2em;

      .dropdown.project-menu {
        float: right
      }
      .dropdown-menu {
        min-width: 9rem;
      }
      img {
        max-width: 150px;
      }
      .is-finished-icon i {
        color: @accentColor
      }
      .clase-info {
        font-size: 12px;
        color: @primaryTextColor
      }
    }

  }
  .project-list{
    flex-wrap: wrap;
  }

  .header {
    background: white;

    & > div {
      justify-content: center;
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
    }

    .name {
      // font-size: 2em;
    }
    .description {
      color: #0008;
    }
  }

  li.alumno {
    display: inline-block;
    margin-right: 1rem;
  }

  .profile {
    display: flex;
    flex-direction: column;
    align-items: center;

    .picture {
      background: #eee;
      width: 100px;
      height: 100px;
      border-radius: 100px;
      margin-bottom: 10px;

      img {
        width: 100px;
        max-width: 100px;
        margin: auto;
        border-radius: 100px;
      }
    }

    .profile-info {
      text-align: center;
    }
  }

  .tab-content {
    min-height: 50vh;
  }

  .class-alumn-subsection{
    margin-top:1em;

    h2 {
      display: block;
      background-color: @accentColor;
      width: 100%;
      padding: 0 8px;
      color:white
    }

    div.outer-clase {
      margin-right:2em;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/User.vue